import axios from 'axios'

// Dedicated axios instance for the control plane (organization owners
// managing their company + billing). Deliberately NOT the shared
// `instanceAxios` from ./api: that one auto-attaches the Keycloak tenant
// token and auto-logs-out the tenant session on 401 — completely wrong
// behaviour for a separate owner login that has nothing to do with Keycloak.
const controlPlaneApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
})

export const CONTROL_PLANE_TOKEN_KEY = 'cpToken'
export const CONTROL_PLANE_OWNER_KEY = 'cpOwner'

controlPlaneApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(CONTROL_PLANE_TOKEN_KEY)
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }
  return config
})

controlPlaneApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(CONTROL_PLANE_TOKEN_KEY)
      localStorage.removeItem(CONTROL_PLANE_OWNER_KEY)
    }
    return Promise.reject(error)
  }
)

export default controlPlaneApi
